<div class="op-assignee-board-header" *ngIf="user">
  <op-principal
    *ngIf="user.id"
    [principal]="user"
    [hideName]="true"
    size="mini"
  ></op-principal>
  <h2 class="editable-toolbar-title--fixed">
    <small [textContent]="text.assignee"></small>
    <br/>
    <a *ngIf="user.id"
       [href]="pathHelper.userPath(user.id)"
       [textContent]="user.name"
       target="_blank">
    </a>
    <span *ngIf="!user.id"
      [textContent]="user.name">
    </span>
  </h2>
</div>
